import { useState } from "react"
import { router } from "@inertiajs/react"
import { Form, Input } from "@/components/Form"
import Button from "@/components/Button"

const RegistrationForm = ({
  email,
  errors,
}: {
  email: string
  errors: Record<string, string[]>
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const handleSubmit = async (registration: {
    email: string
    time_zone: string
  }) => {
    setIsSubmitting(true)
    router.post(
      "/register",
      { registration },
      {
        onFinish: () => setIsSubmitting(false),
      }
    )
  }

  return (
    <Form
      defaultValues={{ email }}
      errors={errors}
      onSubmit={handleSubmit}
      className="flex flex-col my-2 lg:flex-row"
    >
      <Input name="time_zone" type="hidden" value={timeZone} />
      <div className="flex-1">
        <Input
          name="email"
          placeholder="Enter your email"
          type="email"
          autoComplete="email"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
          className="h-12 px-3 text-center lg:text-left"
          required
          disabled={isSubmitting}
        />
      </div>
      <div className="mt-2 shrink-0 lg:mt-0 lg:ml-2">
        <Button className="h-12" disabled={isSubmitting}>
          {isSubmitting ? "Please wait…" : "Sign up"}
        </Button>
      </div>
    </Form>
  )
}

export default RegistrationForm
